export default {
  token: {
    colorPrimary: '#12b89a',
    colorWarning: '#ee9933',
    colorError: '#e64646',
    colorInfo: '#12b89a',
    colorBorder: '#DCE2E2',
    colorBorderSecondary: '#EFEFEF',
    colorBgMask: 'rgba(0, 0, 0, 0.4)',
    colorBgLayout: '#fff',
    wireframe: false,
    boxShadow: '      0 5px 19px 0 rgba(0, 0, 0, 0.1)  ',
    boxShadowSecondary: '      0 5px 10px 0 rgba(0, 0, 0, 0.05)',
    colorTextTertiary: '#888E8E',
    colorText: '#40464A',
    colorTextQuaternary: '#BFCBCB ',
    colorTextSecondary: '#424649',
    borderRadiusSM: 6,
  },
  components: {
    Cascader: {
      controlItemBgHover: '#F5FFFD',
      lineWidth: 1,
    },
    Button: {
      controlHeight: 40,
      borderRadiusLG: 4,
      fontSizeLG: 14,
      colorTextDisabled: '#fff',
      colorBgContainerDisabled: '#BFCBCB',
    },
    Empty: {
      colorTextDisabled: 'rgba(0, 0, 0, 0.25)',
    },
    Tabs: {
      colorPrimary: '#12b89a',
      colorText: '#888E8E',
      colorPrimaryBorder: '#81dec3',
      colorPrimaryActive: '#07917d',
    },
    Switch: {
      colorTextTertiary: 'rgba(0, 0, 0, 0.45)',
      colorTextQuaternary: '#BFCBCB',
      colorWhite: '#F7F9FA',
      fontSizeIcon: 12,
      colorBgContainer: '#ffffff',
    },
    Form: {
      colorText: '#40464A',
      colorTextHeading: '#424649',
      marginLG: 30,
      margin: 30,
    },
    Input: {
      colorText: '#424649',
      fontSize: 12,
      fontSizeLG: 12,
      controlHeightLG: 46,
      controlHeight: 46,
      controlHeightSM: 40,
      controlPaddingHorizontal: 10,
      controlPaddingHorizontalSM: 10,
    },
    InputNumber: {
      colorText: '#424649',
      fontSize: 12,
      fontSizeLG: 12,
      controlHeightLG: 46,
      controlHeight: 46,
      controlHeightSM: 40,
      controlPaddingHorizontal: 10,
      controlPaddingHorizontalSM: 10,
    },
    Select: {
      fontSize: 12,
      fontSizeLG: 12,
      controlHeightLG: 46,
      controlHeight: 40,
      controlPaddingHorizontal: 10,
    },
    Card: {
      boxShadowCard: '0 6px 20px 0 rgba(0, 0, 0, 0.1)',
    },
    Breadcrumb: {
      fontSize: 16,
      colorText: '#424649',
    },
    Drawer: {
      padding: 18,
      paddingLG: 30,
      colorBgElevated: '#F8F9FA',
    },
    Table: {
      borderRadiusLG: 0,
    },
  },
}
